export const initialFilters = {
  size: 16,
  filters: [
    {
      filterProperties: {
        type: 'publication_states',
        target: 'product',
      },
      selection: ['PUBLISHED'],
    },
    {
      filterProperties: {
        type: 'distributor',
      },
    },
  ],
  sorts: [{ type: 'random', seed: Date.now() }] as Array<any>,
  selections: [],
  metrics: [
    { type: 'priceFromWithSelection' },
    { type: 'sessionDurationWithSelection' },
    { type: 'taxonomyThemes' },
    { type: 'taxonomyAudiences' },
    { type: 'taxonomyInternals' },
    { type: 'taxonomyPlaces' },
    { type: 'taxonomyPlacesWithSelection' },
    // { type: 'taxonomyFilterCount' },
    { type: 'taxonomyFilterCountWithSelection' },
    { type: 'taxonomyTypes' },
    {
      type: 'timeRangeWithSelection',
      ranges: [
        { minTime: 480, maxTime: 720 },
        { minTime: 720, maxTime: 1020 },
        { minTime: 1020, maxTime: 1440 },
      ],
    },
    {
      type: 'crossedTaxonomyCount',
      taxonomyTypes: ['TYPES', 'THEMES', 'PLACES'],
      crossedTaxonomies: {
        themes: [],
        places: [],
        types: [],
      },
    },
  ] as Array<any>,
  properties: [{ type: 'nextSessionDate' }, { type: 'rating' }, { type: 'product_enrichment_by_distributor' }] as Array<any>,
};
